import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import SummaryShareChargedComponent from '../../../components/purchase-dashboard/group-summary/summary-share.charged';
import {
  getCurrentUserMembership,
  getCurrentPurchase,
} from '../../../selectors/purchase-selector';
import { SHARED_NAMESPACE } from '../../../actions';
import Purchase from '../../../lib/purchase';
import { Money } from '../../../lib/money';
import { AUTHORIZED, CAPTURED } from '../../../lib/contribution-statuses';

class SummaryShareCharged extends Component {
  render() {
    return (
      <SummaryShareChargedComponent
        membership={this.props.membership}
        purchase={this.props.purchase}
        contributionAmount={this.props.contributionAmount}
        currentProductCostAmount={this.props.currentProductCostAmount}
        splitType={this.props.splitType}
        paymentDate={this.props.paymentDate}
        nextPayment={this.props.nextPayment}
        nextPaymentDate={this.props.nextPaymentDate}
        refundableAmount={this.props.refundableAmount}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { memberships } = state;
  const purchase = getCurrentPurchase(state);
  const membership = getCurrentUserMembership(state);
  const projectedMembership = get(state.projections,
    `${SHARED_NAMESPACE}.memberships.${memberships.current}`);
  const { contributions } = membership;
  let contributionAmount = Money.zero(purchase.currencyCode);
  let paymentDate;
  const singlePayment = Purchase.isSinglePayment(purchase.payments);
  const isActive = Purchase.isActive(purchase.status);
  let projectedPayments;
  let nextPayment;
  let refundableAmount;

  if (projectedMembership && isActive && !singlePayment && purchase.currentPayment) {
    projectedPayments = projectedMembership.contributions.map((contribution, i) => {
      return {
        amount: contribution.amount,
        dueDeadline: contribution.dueDeadline,
      };
    });
    nextPayment = projectedPayments[purchase.currentPayment.number - 1];
    refundableAmount = projectedMembership.refundableAmount;
  }

  if (contributions) {
    const chargedContributions = contributions.filter((c) => {
      return c.status === AUTHORIZED || c.status === CAPTURED;
    });
    const prevContribution = chargedContributions[chargedContributions.length - 1];
    contributionAmount = prevContribution.amount;
    paymentDate = prevContribution.chargedAt;
  }

  return {
    membership,
    purchase,
    costRange: purchase.costRange,
    contributionAmount,
    currentProductCostAmount: purchase.currentProductCostAmount,
    nextPayment,
    paymentDate,
    refundableAmount,
    splitType: purchase.group.splitType,
  };
};

export default connect(mapStateToProps)(SummaryShareCharged);




// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/group-summary/summary-share-charged.container.js